// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'video-player';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.955 1.031h14.09s.924 0 .924.924v14.09s0 .924-.924.924H1.955s-.924 0-.924-.924V1.955s0-.924.924-.924z' />
    <path d='M6.956 10.284a.443.443 0 0 1-.408 0 .369.369 0 0 1-.204-.324V5.27a.369.369 0 0 1 .204-.324.443.443 0 0 1 .408 0l4.494 2.345a.357.357 0 0 1 0 .649zm-3.8 3.497h11.688m-3.188-1.062v2.125' />
  </g>
);

export const viewBox = '0 0 18 18';
